"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactApollo = require("react-apollo"),
    _Uploader = require("../../Uploader"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _AuthorisationWrapper = require("../../AuthorisationWrapper"),
    _AssetLibrary = _interopRequireDefault(require("../components/AssetLibrary")),
    _queries = require("../queries");

function AssetLibrary(a) {
  var b = a.history,
      c = a.showActiveFilter,
      d = a.listProps;
  return _react["default"].createElement(_reactApollo.ApolloConsumer, null, function (a) {
    return _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (e) {
      var f = e.selectedOrganisation,
          g = f.organisationId,
          h = f.name,
          i = f.permissions;
      return _react["default"].createElement(_RequestProvider["default"], {
        requests: {
          getAssetSummariesAndCount: (0, _queries.getAssetSummariesAndCountQuery)(g),
          deleteAsset: (0, _queries.deleteAssetApi)()
        }
      }, function (e) {
        var f = e.getAssetSummariesAndCount,
            j = e.deleteAsset;
        return _react["default"].createElement(_Uploader.UploaderConsumer, null, function (e) {
          var k = e.assetsMap,
              l = e.removeAsset;
          return _react["default"].createElement(_AssetLibrary["default"], {
            getAssetSummariesAndCount: f,
            history: b,
            apolloClient: a,
            assetsMap: k,
            organisationId: g,
            removeFromAssetsMap: l,
            organisationName: h,
            deleteAsset: j,
            orgPermissions: i,
            showActiveFilter: c,
            listProps: d
          });
        });
      });
    });
  });
}

var _default = AssetLibrary;
exports["default"] = _default;